var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { SpinnerButton } from './Ui/SpinnerButton/SpinnerButton';
import { appOrderState, appPaymentState, appProductState, appProgressState, useProgress, useSetAppErrors, } from '../Domain/State/AppState';
import { AppServiceContext } from '../Domain/Context/AppServiceContext';
import { useTrackPageWithCustomDimensions } from '../Tracking';
export function Summary() {
    var orderService = (useContext(AppServiceContext) || {}).orderService;
    var _a = useRecoilValue(appProgressState), steps = _a.steps, switching = _a.switching;
    var paymentTranslation = useRecoilValue(appPaymentState).translation;
    var billingPlanLabel = useRecoilValue(appProductState).billingPlanLabel;
    var _b = useRecoilState(appOrderState), order = _b[0], setOrder = _b[1];
    var _c = useProgress(), stepForward = _c.stepForward, stepBackward = _c.stepBackward, setSwitching = _c.setSwitching;
    var updateErrorMessage = useSetAppErrors().updateErrorMessage;
    var keyTranslations = {
        firstName: 'Vorname',
        lastName: 'Nachname',
        phoneNumber: 'Telefonnummer',
        company: 'Unternehmen',
        countryCode: 'Land',
        street: 'Straße',
        city: 'Stadt',
        postcode: 'PLZ',
    };
    var countryCodeTranslations = {
        DE: 'Deutschland',
    };
    useEffect(function () {
        setSwitching(false);
    }, []);
    function handleClick() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setSwitching(true);
                if (orderService) {
                    orderService
                        .completeCheckout(order === null || order === void 0 ? void 0 : order.tokenValue, setOrder)
                        .then(function () {
                        stepForward();
                    })
                        .catch(function (error) {
                        updateErrorMessage("Bitte kontaktieren Sie den Webseiten-Support. Fehler: ".concat(error.statusCode, " ").concat(error.message));
                    });
                }
                return [2 /*return*/];
            });
        });
    }
    useTrackPageWithCustomDimensions();
    return (_jsxs("div", __assign({ className: "preview-page" }, { children: [_jsx("h2", __assign({ className: "preview-page__headline style-h2" }, { children: "Zusammenfassung" })), order
                && _jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "preview-page__summary" }, { children: [_jsx("h3", __assign({ className: "preview-page__headline style-h3" }, { children: steps[0].label })), _jsx("table", { children: _jsxs("tbody", { children: [order === null || order === void 0 ? void 0 : order.items.map(function (orderItem) { return (_jsxs("tr", __assign({ className: "preview-page__summary__product-row" }, { children: [_jsx("td", { children: orderItem.productName }), _jsxs("td", { children: [_jsxs("div", { children: [orderItem.quantity, "x"] }), _jsx("div", { children: billingPlanLabel })] })] }), "".concat(orderItem.id, "-").concat(orderItem.productName))); }), _jsxs("tr", { children: [_jsx("td", { children: "Gesamt Pro Monat (Zzgl. MwSt.)" }), _jsx("td", { children: _jsxs("div", { children: [((order.total - order.taxTotal) / 100).toFixed(2).replace('.', ','), "\u20AC"] }) })] })] }) }), _jsx("hr", {}), _jsx("h3", __assign({ className: "preview-page__headline style-h3" }, { children: steps[1].label })), _jsx("table", { children: _jsx("tbody", { children: Object.keys(order === null || order === void 0 ? void 0 : order.billingAddress).map(function (key) { return (_jsxs("tr", { children: [_jsx("td", { children: keyTranslations[key] }), _jsx("td", { children: key === 'countryCode' ? countryCodeTranslations[order === null || order === void 0 ? void 0 : order.billingAddress[key]] : order === null || order === void 0 ? void 0 : order.billingAddress[key] })] }, key)); }) }) }), _jsx("hr", {}), _jsx("h3", __assign({ className: "preview-page__headline style-h3" }, { children: steps[3].label })), _jsx("table", { children: _jsx("tbody", { children: _jsxs("tr", { children: [_jsx("td", { children: "Zahlungsart" }), _jsx("td", { children: paymentTranslation })] }) }) })] })), _jsx("div", __assign({ className: "actions" }, { children: _jsx("nav", __assign({ className: "form-navigation" }, { children: _jsxs("ul", { children: [_jsx("li", __assign({ className: "previous" }, { children: _jsx(SpinnerButton, { caption: "Zur\u00FCck", type: "button", clickHandler: stepBackward, isDisabled: switching, secondary: true }) })), _jsx("li", __assign({ className: "next" }, { children: _jsx(SpinnerButton, { caption: "Kostenpflichtig bestellen", isLoading: switching, clickHandler: handleClick }) }))] }) })) }))] })] })));
}
